import { VersionedAgentSchema } from "@redotech/redo-model/agents/versioned-agent";

export const createVersionedAgent = {
  name: "createVersionedAgent" as const,
  input: VersionedAgentSchema.pick({ name: true, prompt: true }),
  output: VersionedAgentSchema,
};
